import { AliensWordmark, BRAND_RED } from './Brand'

/**
 * The portal's loader (business.aliens.express BrandLoader, ported 2026-10-23): a small saucer carrying a parcel in
 * its beam flies across the faint ALIENS wordmark and lights it up behind it, a speed line grows under it, then the
 * saucer lifts away and the loop starts again (2.2 s). Keyframes live in tokens.css (`brand-loader`).
 */
export function BrandLoader({ size = 30, pad = '48px 0', label }: { size?: number; pad?: string; label?: string }) {
  const h = Math.round(size * 0.62)
  return (
    <div className="brand-loader flex flex-col items-center justify-center gap-3" style={{ padding: pad, direction: 'ltr' }} role="status" aria-label="Loading" aria-busy>
      <div className="inline-flex flex-col" style={{ gap: Math.max(5, Math.round(h * 0.35)), paddingTop: Math.round(h * 1.1) }} aria-hidden>
        <div className="relative">
          <span className="block opacity-[0.14]"><AliensWordmark className="block w-auto" style={{ height: h }} /></span>
          <span className="bl-lit absolute left-0 top-0 block"><AliensWordmark className="block w-auto" style={{ height: h }} /></span>
          <span className="bl-ship pointer-events-none absolute flex flex-col items-center" style={{ bottom: -2, width: Math.round(h * 2.2), marginLeft: -Math.round(h * 1.1) }}>
            <svg className="bl-saucer block h-auto w-full" viewBox="0 0 64 26">
              <path d="M21 14a11 10 0 0 1 22 0Z" fill="rgba(124, 58, 237, 0.18)" stroke={BRAND_RED} strokeWidth="1.6" />
              <path d="M27 8.5a6 5 0 0 1 5-2.4" fill="none" stroke="#ffffff" strokeOpacity="0.7" strokeWidth="1.4" strokeLinecap="round" />
              <ellipse cx="32" cy="17" rx="29" ry="7" fill={BRAND_RED} />
              <ellipse cx="32" cy="15" rx="22" ry="2.2" fill="#ffffff" fillOpacity="0.16" />
              <circle className="bl-light" cx="18" cy="18" r="1.8" fill="#ffffff" />
              <circle className="bl-light" cx="32" cy="19.4" r="1.8" fill="#ffffff" style={{ animationDelay: '0.18s' }} />
              <circle className="bl-light" cx="46" cy="18" r="1.8" fill="#ffffff" style={{ animationDelay: '0.36s' }} />
            </svg>
            <span className="bl-beam relative -mt-px flex w-[92%] justify-center" style={{ height: Math.round(h * 1.25) }}>
              <svg className="bl-parcel mt-0.5 h-auto" style={{ width: Math.max(8, Math.round(h * 0.5)) }} viewBox="0 0 20 18">
                <path d="M2 5 10 1l8 4v9l-8 4-8-4Z" fill="#E7C9A0" stroke={BRAND_RED} strokeWidth="1.3" strokeLinejoin="round" />
                <path d="M2 5l8 4 8-4M10 9v9" fill="none" stroke={BRAND_RED} strokeWidth="1.3" strokeLinejoin="round" />
                <path d="M6 3l8 4" stroke={BRAND_RED} strokeWidth="1.1" strokeOpacity="0.55" />
              </svg>
            </span>
          </span>
        </div>
        <span className="bl-speed h-0.5 rounded-sm" />
      </div>
      {label && <span className="text-[12.5px] text-fg-subtle">{label}</span>}
    </div>
  )
}
